import React from 'react';
import RolesPermissionsSection from '../../../sections/AdminDashboard/Settings/RolesPermissions';

const RolesPermissions = () => {
  return <RolesPermissionsSection />;
};

export default RolesPermissions;

